<template>
	<div v-if="visible" class="form" :style="style" :class="clazz">
		<div class="form-head">
			<div class="form-head-left"><component v-if="dg.header" :is="componentOfPart(dg.header)" :part="partRef(dg.header)" :data="localData" :readonly="ro" :viewmode="vm"></component></div>
			<div class="form-head-right"><component v-if="dg.secondaryHeader" :is="componentOfPart(dg.secondaryHeader)" :part="partRef(dg.secondaryHeader)" :data="localData" :readonly="ro" :viewmode="vm"></component></div>
		</div>
		<div class="form-error-body e2e is-container" v-if="errors.length > 0">
			<api-error v-for="err in errors" tag="div" :level="err.level" :message="err.message" class="no-border e2e-padding"></api-error>
		</div>
		<div v-for="item in dg.items" class="form-body">
			<component :is="componentOfPart(item)" :part="partRef(item)" :data="localData" :readonly="ro" :viewmode="vm"></component>
		</div>
		<div class="form-foot">
			<div class="form-foot-left">
				<component v-if="dg.secondaryControls" :is="componentOfPart(dg.secondaryControls)" :part="partRef(dg.secondaryControls)" :data="localData" :readonly="ro" :viewmode="vm"></component>
			</div>
			<div class="form-foot-right">
				<component v-if="dg.controls" :is="componentOfPart(dg.controls)" :part="partRef(dg.controls)" :data="localData" :readonly="ro" :viewmode="vm"></component>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import useContainer, {type ContainerProps, containerProps} from "./Container";
import type {Dialog} from "@t/fd/layout/Dialog";
import {computed} from "vue";
import ApiError from "@fd/helpers/ApiError.vue";

const uprops = defineProps({...containerProps});
const props = uprops as ContainerProps;

const dg = computed<Dialog>(() => props.part as Dialog);
const { visible, clazz, style, componentOfPart, partRef, localData, ro, vm, errors } = useContainer(props);
</script>

<style>
</style>
